import classNames from 'classnames/bind';
import React, { useLayoutEffect, useRef } from 'react';
import { RiCloseLine } from 'react-icons/ri';

import styles from './Window.module.scss';

const cx = classNames.bind(styles);

const Window = ({ title, color, onClose, children }) => {
  const containerRef = useRef();
  const isDragging = useRef(false);
  const offset = useRef({ x: 0, y: 0 });

  useLayoutEffect(() => {
    const windowWidth = containerRef.current.offsetWidth;
    const windowHeight = containerRef.current.offsetHeight;

    const nextTop = (window.innerHeight - windowHeight) / 2;
    const nextLeft = (window.innerWidth - windowWidth) / 2;

    containerRef.current.style.top = `${nextTop}px`;
    containerRef.current.style.left = `${nextLeft}px`;
  }, []);

  const startDrag = (e) => {
    if (e.button !== 0) return; // 왼쪽 클릭만 허용

    isDragging.current = true;

    const { top, left } = containerRef.current.getBoundingClientRect();
    offset.current.x = e.clientX - left;
    offset.current.y = e.clientY - top;

    document.addEventListener('mousemove', onDrag);
    document.addEventListener('mouseup', endDrag);
  };

  const onDrag = (e) => {
    if (!isDragging.current) return;

    let nextLeft = e.clientX - offset.current.x;
    let nextTop = e.clientY - offset.current.y;

    const maxLeft = window.innerWidth - containerRef.current.offsetWidth - 40; // Side Bar Right's Width (40)
    const maxTop = window.innerHeight - containerRef.current.offsetHeight - 56; // Bottom Bar's Height (56)

    // 수평 이동 제한
    nextLeft = Math.max(0, Math.min(nextLeft, maxLeft));
    // 수직 이동 제한
    nextTop = Math.max(56, Math.min(nextTop, maxTop)); // Topbar's Height (56)

    containerRef.current.style.left = `${nextLeft}px`;
    containerRef.current.style.top = `${nextTop}px`;
  };

  const endDrag = () => {
    isDragging.current = false;

    document.removeEventListener('mousemove', onDrag);
    document.removeEventListener('mouseup', endDrag);
  };

  return (
    <div ref={containerRef} className={cx('container')}>
      {color && <div className={cx('color')} style={{ backgroundColor: color }} />}
      <div className={cx('header')} onMouseDown={startDrag}>
        <div className={cx('title')}>{title}</div>
        <div className={cx('button')} onClick={onClose}>
          <RiCloseLine size={16} color="white" />
        </div>
      </div>
      <div className={cx('body')}>{children}</div>
    </div>
  );
};

export default Window;
